import numeral from 'numeral';
import $ from 'jquery';
import moment from 'moment';
import momentTimezone from 'momentTimezone';
import jstz from 'jstimezonedetect';


var Utils = {
    toText: function(text){
        return String(text).replace(/<[^>]+>/gm, '');
    },
    
    truncate: function(text, length){
        if (text) {
            var ellipsis = text.length > length ? "..." : "";
            return text.slice(0, length) + ellipsis;
        };
        return text;        
    },
    
    matchExact: function(text, obj){
        return obj[0] == obj[1];        
    },
    
	isNumber: function(num) {
		return !isNaN(num);
	},
	
    convertCFJSON: function(data){
        var array = []
        var l,i;
		if(data.DATA) {
			for(i = 0; i < data.DATA.length; i++){
				var newValue = []
				for(l = 0; l < data.COLUMNS.length; l++){
					newValue[''+data.COLUMNS[l]] = data.DATA[i][l];
				}
				array.push(newValue);
			}
		}
        return array;
    },
	getDateString: function(date){
		const tzone = jstz.determine();
		let zones = {
			TimeZone: tzone.name(),
			tzShort: moment.tz.zone(tzone.name())
		};
		var splitDate = date.split(" ");
		var newDate = splitDate[0].split("-");
		var times = splitDate[1].split(":");
		var date = new Date(newDate[0], (newDate[1] - 1), newDate[2], times[0], times[1], times[2].split('.')[0], times[2].split('.')[1]);
		return moment(date).tz(zones.TimeZone).format('MMMM Do YYYY');
	},
	IsDefined: function(data){
		return (data !== "undefined" && data != undefined);
	},
	
	NotNull: function(data) {
		return (data != null || data !== null);
	},
	isEven: function(value) {
		if (value%2 == 0)
			return true;
		else
			return false;
	},
	
	keepNumeric: function(value){
		return value.replace(/[^0-9]+/, '');
	},
	
	keepMoney: function(value){
		var ex = /[^0-9\.]+/;
		return value.replace(ex, "");
	},
	
	validMoneyValue: function(value) {
		return !!value.toString().match(/^\$?(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+)?\.[0-9]{1,2}$/);
	},
	
	cleanImgPath: function(path){
		return path.replace('..//', '/');
	},
	
	isValidEmail: function(emailAddress) {
		var validateEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return validateEmail.test(emailAddress);
	},
	
	InObjArray: function(arr, prop, value){
		return arr.some(function(el) {
			return el[prop] === value;
		});
	},
	getObjInArray: function(arr, prop, value){
		for (let i = 0; i < arr.length; i++) {
			if(arr[i][prop] == value)
				return arr[i];
		};
		return false;
	},
    isMobile: {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
        },
        any: function() {
            return (Utils.isMobile.Android() || Utils.isMobile.BlackBerry() || Utils.isMobile.iOS() || Utils.isMobile.Opera() || Utils.isMobile.Windows());
        }
    },
        
    successFail: {
        // Create Function: Pass text, backgroundColor and text color to function
        message: function (text, fill, tColor) {
            text = typeof text !== 'undefined' ? text : 'Please complete all required fields before clicking "Next"';
            fill = typeof fill !== 'undefined' ? fill : 'success';
            tColor = typeof tColor !== 'undefined' ? tColor : '#ffffff';
            var randNum = Math.round(Math.random() * (5000 - 100) + 5);
            var html = '<div id="notify_'+randNum+'" class="successFail clearfix '+fill+'">';
                html+= text;
                html+= '</div>';
            var notifyCount = $('.successFail').length;
            if(notifyCount > 0){
                $('.successFail:first').before(html)
            }else{
                $('body').append(html)
            }
            $('#notify_'+randNum).fadeIn(200).delay(5000).fadeOut(400, function(){
                $('#notify_'+randNum).remove();
            });
            $('.successFail').each(function(index, element) {
                var id = $(this).attr('id');
                $('#'+id).css({bottom: (($(this).height() + 30) * index) + 20},200);
            });
            var windowWidth = document.documentElement.clientWidth;
            if(windowWidth < 640){
                $('.successFail').css({
                    "position": "fixed",
                    "bottom": 0,
                    "left": 0,
                    width: '100%'
                });
            }
            $(window).resize(function(){
                var windowWidth = document.documentElement.clientWidth;
                if(windowWidth > 640){
                    $('.successFail').css({
                        "position": "fixed",
                        "bottom": 20,
                        "left": 20,
                        width: 300
                    });
                }else{
                    $('.successFail').css({
                        "position": "fixed",
                        "bottom": 0,
                        "left": 0,
                        width: '100%'
                    });
                }
            });
        }
    },
    
    notification: {
		message: function (header, text, hlink) {
			header = typeof header !== 'undefined' ? header : '';
			text = typeof text !== 'undefined' ? text : 'Please complete all required fields before clicking "Next"';
			var randNum = Math.round(Math.random() * (5000 - 100) + 5);
			var clickable = hlink && hlink.length > 0 ? () => {window.location.href = hlink} : () => {};
            var html = '<div id="notification_'+randNum+'" class="notification clearfix" onClick="'+clickable.bind(this)+'"><i class="notifyDelete glyphicon glyphicon-remove"></i>';
                html+= '<div class="notificationHeader">'+header+'</div>';
                html+= text;
                html+= '</div>';
            var notifyCount = $('.notification').length;
            if(notifyCount > 0){
                $('.notification:first').before(html)
            }else{
                $('body').append(html)
            }
            $('#notification_'+randNum).css({right: 0 - ($('#notification_'+randNum).width() + 20)});
			if(windowWidth < 640){
				$('#notification_'+randNum).fadeIn(200).delay(5000).fadeOut(400, function(){
					$('#notification_'+randNum).remove();
				});
			} else {
				$('#notification_'+randNum).fadeIn(200)
			}
			$('.notifyDelete').on('click', function() {
				$('#notification_'+randNum).fadeOut(400, function(){
					$('#notification_'+randNum).remove();
				});
			})
            $('.notification').each(function(index, element) {
                var id = $(this).attr('id');
                $('#'+id).css({top: (($(this).height() + 30) * index) + 80, right: 10},200);
            });
            var windowWidth = document.documentElement.clientWidth;
            if(windowWidth < 640){
                $('.notification').css({
                    "position": "fixed",
                    "top": 0,
                    "right": 0,
                    width: '100%'
                });
            }
            $(window).resize(function(){
                var windowWidth = document.documentElement.clientWidth;
                if(windowWidth > 640){
                    $('.notification').css({
                        "position": "fixed",
                        "top": 80,
                        "right": 10,
                        width: 300
                    });
                }else{
                    $('.notification').css({
                        "position": "fixed",
                        "bottom": 0,
                        "left": 0,
                        width: '100%'
                    });
                }
            });
        }
    },
	
	setUploader: function(data){
		//objectValues = {
		//	attachType:'',
		//	page: '',
		//	button: '',
		//	fileTag: '',
		//	multiSelect: '',
		//  filters: {},
		//	itemID: '',
		//	filesAdded: () => {},
		//	progress: () => {},
		//	fileUploaded: () => {}
		//}
		let multiSelect = Utils.IsDefined(data.multiSelect) ? data.multiSelect : true;
		var URLitemID = Utils.IsDefined(data.itemID) ? "&ItemID=" + data.itemID + "&addImage" : "";
		let filters = Utils.IsDefined(data.filters) ? data.filters : {max_file_size : '10mb',mime_types: [{title : "Image files", extensions : "jpg,gif,png"}]};

		var uploader = new plupload.Uploader({
			runtimes : 'html5,flash,silverlight,html4',
			browse_button : data.button,
			multipart: true,
			multi_selection: data.multiSelect,
			url : "/includes/actUploadImage.cfm?AttachType=" + data.attachType + "&fileTag=" + data.fileTag + "" + URLitemID,

			filters : {
				max_file_size : '10mb',
				mime_types: [
					{title : "Image files", extensions : "jpg,gif,png"}
				]
			},

			// Flash settings
			flash_swf_url : '/scripts/plupload/js/Moxie.swf',

			// Silverlight settings
			silverlight_xap_url : '/scripts/plupload/js/Moxie.xap',

			init: {
				PostInit: function() {
				},

				FilesAdded: function(up, files) {
					plupload.each(files, function(file) {
						data.filesAdded(file);
					});
					uploader.start();
				},

				UploadProgress: function(up, file) {
					data.progress(file);
				},
				FileUploaded: function(up, file, response) {
					var fileInfo;
					try {
						fileInfo = jQuery.parseJSON(response);
					} catch(err) {
						fileInfo = eval('(' + response.response + ')');
					}
					
					data.fileUploaded(fileInfo);
					
				},
				Error: function(up, err) {
					console.log("\nError #" + err.code + ": " + err.message);
					Utils.successFail.message(err.message,'error');
				}
			}
		});
		uploader.init();
	},
	formAlert: {
		// Initialize by setting Default text
		init: function () {},
		// Create Function: Pass text, backgroundColor and text color to function
		message: function (text, title, bgColor, tColor) {
			text = typeof text !== 'undefined' ? text : 'Please complete all required fields before clicking "Next"';
			title = typeof title !== 'undefined' ? title : 'Alert';
			bgColor = typeof bgColor !== 'undefined' ? bgColor : 'orangeDark';
			tColor = typeof tColor !== 'undefined' ? tColor : '#ffffff';
			var html = '<div class="formAlert '+bgColor+'" style="color:'+tColor+'">';
				html+= '<h2>'+title+'</h2><i class="glyphicon glyphicon-remove" id="closeAlert" style="position:absolute"></i>';
				html+= text;
				html+= '<div style="clear:both"></div></div>';
			$('body').append(html);
			var windowHeight = document.documentElement.clientHeight;
			var windowWidth = document.documentElement.clientWidth;
			var popupWidth = $('.formAlert').width();
			var popupHeight = $('.formAlert').height();
			var left = windowWidth/2 - popupWidth/2 - 10;

			if(windowWidth > 640){
				$('.formAlert').css({
					"position": "fixed",
					"top": windowHeight/2 - popupHeight/2,
					"left": left
				});
			}else{
				$('.formAlert').css({
					"position": "fixed",
					"top": windowHeight/2 - popupHeight/2,
					"left": 'inherit',
					margin: '0 5%'
				});
			}
			setTimeout(function(){
				$('html, body').delay(600).one('click',function(){$('.formAlert').remove();});
			},600);
			$(window).resize(function(){
				var windowHeight = document.documentElement.clientHeight;
				var windowWidth = document.documentElement.clientWidth;
				var popupWidth = $('.formAlert').width();
				var popupHeight = $('.formAlert').height();
				var left = windowWidth/2 - popupWidth/2 - 10;
				if(windowWidth > 640){
					$('.formAlert').css({
						"position": "fixed",
						"top": windowHeight/2 - popupHeight/2,
						"left": left
					});
				}else{
					$('.formAlert').css({
						"position": "fixed",
						"top": windowHeight/2 - popupHeight/2,
						"left": 'inherit',
						margin: '0 5%'
					});
				}
			});
		}
	},
	currencyFormat: function(value) {
		return numeral(value).format('$0,0.00')
	}
}

export default Utils;


/** WEBPACK FOOTER **
 ** ./app/util/util.js
 **/